<template>
  <div>
    <l-tables
      ref="table"
      :tableConfig="tableConfig"
      :searchParams="searchData"
      :noCreatText="noCreatText"
      :ImgSrc="nullImg"
      :emptyImgSrc="emptyImgSrc"
      @tableChange="handleTableHeaderChange"
    >
      <template slot="searchConditions">
        <div class="search-conditions">
          <a-input
            v-model="keyword"
            @change="search"
            maxlength="30"
            :placeholder="$t('teacherList.searchPlaceholder')"
            class="search-item"
          >
            <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
            <img
              class="clear"
              v-if="keyword"
              slot="suffix"
              @click=";(keyword = undefined), search()"
              :src="require('@/assets/icons/icon_gb.png')"
            />
          </a-input>
        </div>
      </template>
      <template slot="searchActions">
        <a-button type="primary" @click="create">{{ $t('teacherList.createButton') }}</a-button>
      </template>
      <template slot="importFile">
        <a-button
          type="primary"
          @click="uploadVisible = true"
          class="import"
          style="margin-right: 10px;background: linear-gradient( 227deg, #72899D 0%, #9BB3C8 100%);"
          >{{ $t('teacherList.batchImport') }}</a-button
        >
      </template>
      <template #role="{ record }">
        <div style="position: relative">
          <a href="#" v-if="record.roleName !== '--'">{{ record.roleName }}</a>
          <a href="#" v-else>{{ $t('teacherList.selectRole') }}</a>
          <a-cascader
            class="search-item"
            :options="roleList"
            :placeholder="$t('teacherList.selectRole')"
            @change="value => setRoleChange(value, record.id)"
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;opacity: 0"
          >
            <a href="#">{{ $t('teacherList.selectRole') }}</a>
          </a-cascader>
        </div>
        <!-- <span v-if="record.roleName !== '--'">{{ record.roleName }}</span>
        <span v-else>
          <a-cascader
            class="search-item"
            :options="roleList"
            placeholder="请选择角色"
            @change="value => setRoleChange(value, record.id)"
          >
            <a href="#">请选择角色</a>
          </a-cascader>
        </span> -->
      </template>
      <template #profession="{ record }">
        <span v-if="record.profession">{{ record.profession }}</span>
        <span v-else>
          <a-cascader
            class="search-item"
            :options="professionList"
            placeholder="请选择专业"
            @change="value => setProfessionChange(value, record.id)"
          >
            <a href="#">请选择专业</a>
          </a-cascader>
        </span>
      </template>
      <template #status="{ record }">
        {{ record.status === '1' ? $t('teacher.enable') : $t('teacher.disable') }}
      </template>
    </l-tables>

    <upload-modal
      :visible="uploadVisible"
      :title="$t('teacherList.bulkImportTitle')"
      @upload="handleUpload"
      @cancel="uploadVisible = false"
      @fileChange="handleFileChange"
      @downloadTemplate="downloadTemplate"
    />
  </div>
</template>

<script>
import LTables from '@/components/LTables/index.vue'
import UploadModal from '@/components/UploadModal.vue'
import { teacherImport, updateTeacherProfession, updateTeacherRole, getRoleList } from '@/api/admin'
import { getAdminOrgList } from '@/api/lesson'

export default {
  components: {
    LTables,
    UploadModal
  },
  data() {
    return {
      selectedValue: undefined,
      uploadVisible: false,
      teacherFile: null,
      noCreatText: this.$t('teacherList.empty'),
      nullImg: require('@/assets/img/pic_gg@2x.png'),
      emptyImgSrc: require('@/assets/img/bj_zanwu_2.png'),
      keyword: undefined,
      selectedProfession: [],
      professionList: [],
      professionSearchList: [],
      roleList: [],
      searchData: {
        keyword: '',
        college_id: '',
        department_id: '',
        professionId: ''
      },
      nullImg: require('@/assets/img/trainingRoomlistNull.png')
    }
  },
  computed: {
    tableConfig() {
      return {
        tableName: this.$t('teacherList.title'),
        tableColumns: [
          {
            title: this.$t('teacherList.id'),
            dataIndex: 'index',
            key: 'index',
            align: 'center'
          },
          {
            title: this.$t('teacherList.name'),
            dataIndex: 'name',
            key: 'name',
            align: 'center'
          },
          {
            title: this.$t('teacherList.account'),
            dataIndex: 'username',
            key: 'username',
            align: 'center'
          },
          {
            title: this.$t('teacherList.createTime'),
            dataIndex: 'createdAt',
            key: 'createdAt',
            align: 'center',
            width: '200px'
          },
          {
            title: this.$t('teacherList.status'),
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            scopedSlots: { customRender: 'status' }
          },
          {
            title: this.$t('teacherList.actions'),
            dataIndex: 'operate',
            key: 'operate',
            align: 'center',
            scopedSlots: { customRender: 'operate' }
          }
        ],
        tableDeleteTip: {
          title: this.$t('teacherList.deleteConfirmTitle'),
          content: this.$t('teacherList.deleteConfirmContent')
        },
        tablePort: {
          list: '/teacher/list',
          del: '/teacher/delete'
        },
        tableEditRouteNName: 'teacherAdd'
      }
    }
  },
  methods: {
    async getRoleList() {
      try {
        const res = await getRoleList()
        if (res.code === 200) {
          this.roleList = res.data.list.map(item => ({
            value: item.id,
            label: item.name
          }))
        }
      } catch (error) {
        console.error('获取角色列表失败:', error)
        this.$message.error(this.$t('teacherList.getRoleListFailed'))
      }
    },
    search() {
      this.searchData.keyword = this.keyword
    },
    handleTableHeaderChange([filters, getList]) {
      getList()
    },
    create() {
      this.$router.push({
        name: 'teacherAdd'
      })
    },
    handleFileChange(file) {
      this.teacherFile = file
    },
    handleUpload() {
      if (!this.teacherFile) {
        this.$message.error(this.$t('teacherList.uploadRequired'))
        return
      }
      console.log(this.teacherFile)
      const formData = new FormData()
      formData.append('file', this.teacherFile)

      teacherImport(formData).then(res => {
        if (res.code !== 200) return
        this.uploadVisible = false
        this.$message.success(this.$t('teacherList.importSuccess'))
        this.$refs.table.getList()
      })
    },
    downloadTemplate() {
      // window.open('/static/xlsx/' + this.$t('teacherList.templateFileName'))
      location.href = '/static/xlsx/' + this.$t('teacherList.templateFileName')
    },
    getProfessionList() {
      getAdminOrgList().then(res => {
        if (res.code === 200) {
          this.professionListFind = []
          for (let item of res.data.list) {
            this.professionList.push({
              value: item.id,
              label: item.name,
              children: item.child.map(items => {
                return {
                  value: items.id,
                  label: items.name,
                  children: items.child.map(itemt => {
                    return {
                      value: itemt.id,
                      label: itemt.name,
                      isLeaf: true
                    }
                  })
                }
              })
            })
            this.professionSearchList.push({
              value: item.id,
              label: item.name,
              disabled: true,
              children: item.child.map(items => {
                return {
                  value: items.id,
                  label: items.name,
                  disabled: true,
                  children: items.child.map(itemt => {
                    this.professionListFind.push({
                      value: itemt.id,
                      label: itemt.name
                    })
                    return {
                      value: itemt.id,
                      label: itemt.name,
                      isLeaf: true
                    }
                  })
                }
              })
            })
          }
        }
      })
    },
    handleProfessionChange(value) {
      console.log(value)
      this.searchData.professionId = value
      this.search()
    },
    resetSearch() {
      this.keyword = undefined
      this.selectedProfession = []
      this.searchData = {
        keyword: '',
        college_id: '',
        department_id: '',
        professionId: ''
      }
      this.search()
    },
    async setProfessionChange(value, id) {
      try {
        const res = await updateTeacherProfession({
          id,
          collegeId: value[0],
          departmentId: value[1],
          professionId: value[2]
        })
        if (res.code == 200) {
          this.$message.success(this.$t('teacherList.professionUpdateSuccess'))
          this.$refs.table.getList()
        }
      } catch (error) {
        console.error('更新专业失败:', error)
        this.$message.error(this.$t('teacherList.professionUpdateFailed'))
      }
    },
    async setRoleChange(value, id) {
      try {
        const res = await updateTeacherRole({
          id,
          roleId: value[0]
        })
        if (res.code == 200) {
          this.$message.success(this.$t('teacherList.roleUpdateSuccess'))
          this.$refs.table.getList()
        }
      } catch (error) {
        this.$message.error(this.$t('teacherList.roleUpdateFailed'))
      }
    }
  },
  mounted() {
    this.getProfessionList()
    this.getRoleList()
  }
}
</script>

<style lang="less" scoped>
/deep/.ant-select-selection--multiple {
  border-radius: 20px;
}
</style>
